var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.filteredPatientMicrohabits.length > 0
        ? _c(
            "div",
            [
              _c(
                "transition-group",
                {
                  staticClass:
                    "row neu-cards-ctn landing-cnt mt-5 row-cols-1 row-cols-xl-4",
                  attrs: { name: "list", tag: "div" }
                },
                _vm._l(_vm.uniquePatientMicrohabitsSorted, function(
                  patientMicrohabit
                ) {
                  return _c("PatientMicrohabitBlock", {
                    key: patientMicrohabit.id,
                    attrs: {
                      patientMicrohabit: patientMicrohabit,
                      categories: _vm.getAllSavedCategories(patientMicrohabit),
                      noBackgroundImage: "",
                      type: _vm.type,
                      showHeartIcon: "",
                      img:
                        patientMicrohabit.microhabit.icon ||
                        _vm.DEFAULT_MICROHABIT_IMAGE
                    },
                    on: { deleted: _vm.loadPatientMicrohabits }
                  })
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.patientMicrohabits || _vm.patientMicrohabits.length === 0
        ? _c(
            "b-row",
            { staticClass: "landing-cnt mt-4", attrs: { cols: "12" } },
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-alert",
                    { attrs: { show: "", variant: "secondary" } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("patient.microhabits.no-microhabits", {
                            typeName: _vm.microhabitI18nName({ plural: false })
                          })
                        )
                      ),
                      _c("br"),
                      _c(
                        "base-button",
                        {
                          staticClass: "mt-4",
                          attrs: { variant: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.$router.push("/patient/microhabits")
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("patient.microhabits.add-microhabit", {
                                typeName: _vm.microhabitI18nName({
                                  plural: true
                                })
                              })
                            )
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.patientMicrohabits &&
      _vm.patientMicrohabits.length > 0 &&
      _vm.filteredPatientMicrohabits.length === 0
        ? _c(
            "div",
            { staticClass: "landing-cnt w-100 mt-4" },
            [
              _c("b-alert", { attrs: { show: "", variant: "secondary" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("patient.microhabits.no-microhabits-with-filters", {
                      typeName: _vm.microhabitI18nName({ plural: true })
                    })
                  )
                )
              ])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7384264e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7384264e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/microhabits/PatientMicrohabitsPanelMenu.vue
// module id = 3112
// module chunks = 61 62